import React from "react";
import { usd, itemKey, personKey } from "../lib/api";
import { useRegistration } from "../context/RegistrationContext";

export default function OrderSummary({ compact = false }) {
  const { quote, participants } = useRegistration();

  return (
    <div data-testid="sticky-order-summary" className="rounded-2xl bg-[#041E14] text-white overflow-hidden shadow-xl">
      <div className="px-5 py-4 border-b border-white/10 flex items-center justify-between">
        <h3 className="font-display font-bold text-lg tracking-tight">Order Summary</h3>
        {quote?.category && (
          <span className="text-[10px] uppercase tracking-widest bg-[#008057] px-2 py-1 rounded-full font-bold">
            {quote.category.name}
          </span>
        )}
      </div>

      <div className={`px-5 py-4 space-y-4 ${compact ? "" : "max-h-[52vh] overflow-y-auto"}`}>
        {!quote && <p className="text-white/60 text-sm">Add participant details to see pricing.</p>}
        {quote?.participants?.map((p, idx) => (
          <div key={personKey(p)} className="border-b border-white/10 pb-3 last:border-0">
            <div className="font-semibold text-[#F3C242] mb-1.5">
              {p.name || `Participant ${idx + 1}`}
            </div>
            {p.items.map((it) => (
              <div key={itemKey(it)} className="flex justify-between text-sm text-white/80 py-0.5">
                <span className="pr-2">{it.label}</span>
                <span className="font-mono whitespace-nowrap">{usd(it.amount)}</span>
              </div>
            ))}
            <div className="flex justify-between text-sm mt-1.5 pt-1.5 border-t border-white/10">
              <span className="text-white/60">Participant subtotal</span>
              <span className="font-semibold">{usd(p.subtotal)}</span>
            </div>
          </div>
        ))}
        {quote?.discount > 0 && (
          <div className="flex justify-between text-sm text-emerald-300">
            <span>Sibling discount</span>
            <span>-{usd(quote.discount)}</span>
          </div>
        )}
      </div>

      <div className="px-5 py-4 bg-[#008057] flex items-center justify-between">
        <span className="font-display font-bold uppercase tracking-wide">Total</span>
        <span data-testid="summary-total-price" className="font-display font-extrabold text-2xl">
          {usd(quote?.total || 0)}
        </span>
      </div>
      {participants?.length > 1 && (
        <div className="px-5 py-2 text-center text-[11px] text-white/50 bg-[#041E14]">
          Family total for {participants.length} participants (all prices in USD)
        </div>
      )}
    </div>
  );
}
